import { render } from "./SlidePreviewHeader.vue?vue&type=template&id=d9901ece&scoped=true"
import script from "./SlidePreviewHeader.vue?vue&type=script&lang=js"
export * from "./SlidePreviewHeader.vue?vue&type=script&lang=js"

import "./SlidePreviewHeader.vue?vue&type=style&index=0&id=d9901ece&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9901ece"]])

export default __exports__